import { useMemo } from "react";

// import images
import ceImage from "../Assets/Images/constr.jpg";
import conImage from "../Assets/Images/cv.jpg";
import qsImage from "../Assets/Images/qs.jpg";
import arcImage from "../Assets/Images/arch.jpg";
import meImage from "../Assets/Images/me.jpg";
import cheImage from "../Assets/Images/ce.jpg";
import peImage from "../Assets/Images/prc.jpg";
import minImage from "../Assets/Images/mining.jpg";

export const Industries = () => {
    const industriesArr = useMemo(() => {
        return [
            {
                image: ceImage,
                title: "Civil Engineering",
                text: "Skill set across spectrum with exposure to a multitude of projects"
            },
            {
                image: conImage,
                title: "Construction Engineering",
                text: "Roles across spectrum of Construction & Consulting"
            },
            {
                image: qsImage,
                title: "Quantity Surveying",
                text: "Assist clients on various projects and briefs"
            },
            {
                image: arcImage,
                title: "Architecture",
                text: "Architectural client footprint includes small firms to multinational corporates"
            },
            {
                image: meImage,
                title: "Mechanical Engineering",
                text: "Within FMCG Manufacturing Plants"
            },
            {
                image: cheImage,
                title: "Chemical Engineering",
                text: "Skillset across Manufacturing and FMCG"
            },
            {
                image: peImage,
                title: "Process Engineering",
                text: "Skillset across Production Manufacturing Plants"
            },
            {
                image: minImage,
                title: "Mining",
                text: "Assist across all levels and geographies, as well as diverse portfolios of mining clients"
            }
        ];
    }, []);

    return (
        <div className="industries-cards">
            {industriesArr.map((ind, index) => (
                <div key={index} className="industry-card">
                    <img src={ind.image} alt="card img" />
                    <div className="text-wrap">
                        <h2>{ind.title}</h2>
                        <p>{ind.text}</p>
                    </div>
                </div>
            ))}
        </div>
    );
}